<template>
  <div>
    <a
      v-if="schedule && schedule.teachableUrl"
      :href="schedule.teachableUrl"
      class="cta-button btn-pill-green"
      data-test-id="cta"
    >
      {{ $t('education.book') }}
    </a>
    <button
      v-else-if="schedule && schedule.variantId"
      class="cta-button cursor-pointer"
      :class="isError ? 'btn-pill-gray' : 'btn-pill-green'"
      :disabled="isLoading || isError"
      data-test-id="cta"
      @click.prevent="addToCart"
    >
      {{ $t('education.book') }}
    </button>
    <em v-if="isError" class="text-red-300">{{ $t('education.invalidUrl') }}</em>
  </div>
</template>

<script>
import { addVariantToCart } from '@/utils/product';

export default defineNuxtComponent({
  name: 'BookEventButton',
  props: {
    schedule: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      product: null,
      variant: null,

      isLoading: false,
      isError: false,
    };
  },

  async created() {
    if (this.schedule?.shopifyProduct) {
      this.product = await this.$shopifyProductByHandle(this.schedule.shopifyProduct);

      const variant = this.product.variants.edges.find((node) => {
        return node.node.id === `gid://shopify/ProductVariant/${this.schedule.variantId}`;
      });

      this.variant = variant ? variant.node : null;
    }
  },

  methods: {
    addToCart() {
      if (this.product) {
        addVariantToCart.call(this, this.product, this.variant, false, null, null);
      } else {
        this.goToCheckout(this.schedule.variantId);
      }
    },

    goToCheckout(variantId) {
      this.isLoading = true;
      this.$educationCheckoutUrl(variantId).then((url) => {
        if (url === null) {
          this.isError = true;
          return false;
        }
        this.isLoading = false;
        window.location.href = url;
      });
    },
  },
});
</script>
